<section class="language-selection-container mx-4 flex h-full flex-col">
    <div class="mt-20 flex justify-center">
        <ion-icon
            class="sr-app-light:text-black gl-light:text-white text-9xl text-white"
            *ngIf="onlyPortraitMode$ | async"
            [ngClass]="{ 'text-white': env.THEME_NAME !== 'varmland' }"
            aria-hidden="true"
            src="{{ assetsPath$ | async }}/img/onboarding/language.svg"></ion-icon>
    </div>

    <h1
        class="sr-app-light:text-black gl-light:text-white mt-7 text-center text-xl font-bold"
        [ngClass]="{ 'text-white': env.THEME_NAME !== 'varmland' }">
        {{ 'ONBOARDING_CHOOSE_LANGUAGE' | translate }}
    </h1>

    <ion-list class="mr-12 mt-3 grow bg-transparent">
        <ion-radio-group (ionChange)="setLanguage($event)" value="{{ (selectedLanguage$ | async)?.code }}">
            <ion-item
                *ngFor="let language of regionLanguages"
                color="{{
                    env.THEME_NAME === 'sormland-v2' || env.THEME_NAME === 'orebro' || env.THEME_NAME === 'varmland'
                        ? 'primary'
                        : 'secondary'
                }}">
                <ion-label class="gl-light:text-white_label text-base">{{ language?.name }}</ion-label>
                <ion-radio mode="md" slot="start" value="{{ language?.code }}"></ion-radio>
            </ion-item>
        </ion-radio-group>
    </ion-list>

    <ion-button
        class="mb-14 w-full"
        [attr.aria-label]="'ONBOARDING_CONTINUE' | translate"
        [color]="continueButtonColor"
        (click)="proceedNextView.emit(onboardingType.ONBOARD_FLOW)"
        size="large">
        <ion-label class="gl-light:text-[var(--color-secondary)] text-base font-bold normal-case">{{
            'ONBOARDING_CONTINUE' | translate
        }}</ion-label>
    </ion-button>
</section>
